import React from "react";
import { Box, Button, Paper, TextField } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { BusinessOwnerLayout } from "frontend/src/pages/layouts";
import { ButtonLoader } from "frontend/src/ui/button-loader";
import { Programs } from "./programs-table";
import { PageSkeleton } from "./page-skeleton";
import { useEditTimetableForm, usePageMount } from "./model";
var useStyles = makeStyles(function (theme) {
    var _a;
    return ({
        buttons: (_a = {
                display: "flex",
                flexDirection: "column",
                "& .MuiButtonBase-root": {
                    marginBottom: theme.spacing(1),
                }
            },
            _a[theme.breakpoints.up("md")] = {
                flexDirection: "row",
                "& .MuiButtonBase-root": {
                    marginBottom: 0,
                    marginRight: theme.spacing(1),
                },
            },
            _a),
    });
});
var Page = function (_a) {
    var initial = _a.initial;
    var classes = useStyles();
    var form = useEditTimetableForm(initial);
    return (React.createElement(Box, { component: "form", onSubmit: form.submit },
        React.createElement(Box, { component: Paper, p: 2 },
            React.createElement(Box, { display: "flex", flexDirection: "column" },
                React.createElement(TextField, { fullWidth: true, value: form.timetable.title.value, onChange: form.changeTitle, error: !!form.timetable.title.error, helperText: form.timetable.title.error, label: "Название сетки вещания" }),
                React.createElement(Box, { mt: 1, className: classes.buttons },
                    React.createElement(ButtonLoader, { type: "submit", variant: "contained", color: "primary", isLoading: form.timetable.update.pending }, "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C"),
                    React.createElement(Button, { variant: "outlined", color: "primary", disabled: form.timetable.update.pending, onClick: form.timetable.entries.add }, "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0440\u0430\u0441\u043F\u0438\u0441\u0430\u043D\u0438\u0435")))),
        form.timetable.entries.items.length > 0 && (React.createElement(Box, { component: Paper, mt: 2 },
            React.createElement(Programs, { entries: form.timetable.entries.items, onEntryRemove: form.timetable.entries.remove, onEntryTitleChange: form.timetable.entries.setTitle, onEntryTimeStartChange: form.timetable.entries.setTimeStart, onEntryTimeEndChange: form.timetable.entries.setTimeEnd, onEntryProgramChange: form.timetable.entries.setProgram, onEntryDaysChange: form.timetable.entries.setWeekday, onEntryInterruptOrderPlayingChange: form.timetable.entries.setInterruptPlaying, onEntryStrictOrderPlayChange: form.timetable.entries.setStrictOrderPlaying, errors: form.timetable.entries.errors })))));
};
export var EditTimetablePage = function () {
    var timetable = usePageMount().timetable;
    return (React.createElement(BusinessOwnerLayout, null, timetable ? React.createElement(Page, { initial: timetable }) : React.createElement(PageSkeleton, null)));
};
